// Generated by purs version 0.15.7
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Class_Console from "../Effect.Class.Console/index.js";
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Freer from "../Freer/index.js";
var show = /* #__PURE__ */ Data_Show.show(/* #__PURE__ */ Data_Show.showArray(Data_Show.showString));
var show1 = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var pure = /* #__PURE__ */ Control_Applicative.pure(Data_Either.applicativeEither);
var map = /* #__PURE__ */ Data_Functor.map(Freer.effFunctor);
var traverse = /* #__PURE__ */ Data_Traversable.traverse(Data_Traversable.traversableArray)(Freer.effApplicative);
var log = /* #__PURE__ */ Effect_Class_Console.log(Effect_Class.monadEffectEffect);
var Noop = /* #__PURE__ */ (function () {
    function Noop() {

    };
    Noop.value = new Noop();
    return Noop;
})();
var LoadVal = /* #__PURE__ */ (function () {
    function LoadVal(value0) {
        this.value0 = value0;
    };
    LoadVal.create = function (value0) {
        return new LoadVal(value0);
    };
    return LoadVal;
})();
var LoadRef = /* #__PURE__ */ (function () {
    function LoadRef(value0) {
        this.value0 = value0;
    };
    LoadRef.create = function (value0) {
        return new LoadRef(value0);
    };
    return LoadRef;
})();
var BinOp = /* #__PURE__ */ (function () {
    function BinOp(value0) {
        this.value0 = value0;
    };
    BinOp.create = function (value0) {
        return new BinOp(value0);
    };
    return BinOp;
})();
var MakeNode = /* #__PURE__ */ (function () {
    function MakeNode(value0) {
        this.value0 = value0;
    };
    MakeNode.create = function (value0) {
        return new MakeNode(value0);
    };
    return MakeNode;
})();
var Store = /* #__PURE__ */ (function () {
    function Store(value0) {
        this.value0 = value0;
    };
    Store.create = function (value0) {
        return new Store(value0);
    };
    return Store;
})();
var SetVal = /* #__PURE__ */ (function () {
    function SetVal(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SetVal.create = function (value0) {
        return function (value1) {
            return new SetVal(value0, value1);
        };
    };
    return SetVal;
})();
var SetRef = /* #__PURE__ */ (function () {
    function SetRef(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    SetRef.create = function (value0) {
        return function (value1) {
            return new SetRef(value0, value1);
        };
    };
    return SetRef;
})();
var Select = /* #__PURE__ */ (function () {
    function Select(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Select.create = function (value0) {
        return function (value1) {
            return new Select(value0, value1);
        };
    };
    return Select;
})();
var Register = /* #__PURE__ */ (function () {
    function Register(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Register.create = function (value0) {
        return function (value1) {
            return new Register(value0, value1);
        };
    };
    return Register;
})();
var Call = /* #__PURE__ */ (function () {
    function Call(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Call.create = function (value0) {
        return function (value1) {
            return new Call(value0, value1);
        };
    };
    return Call;
})();
var instructinoShow = {
    show: function (v) {
        if (v instanceof Noop) {
            return "Noop";
        };
        if (v instanceof LoadVal) {
            return "loadVal(" + (v.value0 + ")");
        };
        if (v instanceof LoadRef) {
            return "LoadRef(" + (show(v.value0) + ")");
        };
        if (v instanceof BinOp) {
            return "BinOp(" + (v.value0 + ")");
        };
        if (v instanceof MakeNode) {
            return "MakeNode(" + (v.value0 + ")");
        };
        if (v instanceof Store) {
            return "Store(" + (show(v.value0) + ")");
        };
        if (v instanceof SetVal) {
            return "SetVal(" + (show1(v.value0) + ("," + (show1(v.value1) + ")")));
        };
        if (v instanceof SetRef) {
            return "SetRef(" + (show1(v.value0) + ("," + (show(v.value1) + ")")));
        };
        if (v instanceof Call) {
            return "Call(" + (show(v.value0) + ("," + (v.value1 + ")")));
        };
        if (v instanceof Register) {
            return "Register(" + (v.value0 + ("->" + (Data_Show.show(Data_Show.showArray(instructinoShow))(v.value1) + ")")));
        };
        if (v instanceof Select) {
            return "Select(" + (Data_Show.show(Data_Show.showArray(instructinoShow))(v.value0) + ("," + (Data_Show.show(Data_Show.showArray(instructinoShow))(v.value1) + ")")));
        };
        throw new Error("Failed pattern match at Machine (line 28, column 1 - line 39, column 78): " + [ v.constructor.name ]);
    }
};
var unsafeRun = /* #__PURE__ */ Freer.unsafeRun(instructinoShow);
var execute = function (v) {
    if (v instanceof Noop) {
        return pure(Data_Unit.unit);
    };
    if (v instanceof LoadVal) {
        return $foreign.loadVal(v.value0, Data_Either.Left.create, Data_Either.Right.create);
    };
    if (v instanceof LoadRef) {
        return $foreign.loadRef(v.value0, Data_Either.Left.create, Data_Either.Right.create);
    };
    if (v instanceof BinOp) {
        return $foreign.binOp(v.value0, Data_Either.Left.create, Data_Either.Right.create);
    };
    if (v instanceof Store) {
        return $foreign.store(v.value0, Data_Either.Left.create, Data_Either.Right.create);
    };
    if (v instanceof MakeNode) {
        return $foreign.makeNode(v.value0, Data_Either.Left.create, Data_Either.Right.create);
    };
    if (v instanceof SetVal) {
        return $foreign.setVal(v.value0, v.value1, Data_Either.Left.create, Data_Either.Right.create);
    };
    if (v instanceof SetRef) {
        return $foreign.setRef(v.value0, v.value1, Data_Either.Left.create, Data_Either.Right.create);
    };
    if (v instanceof Call) {
        return $foreign.call(v.value0, v.value1, Data_Either.Left.create, Data_Either.Right.create);
    };
    if (v instanceof Register) {
        var block = map(Data_Function["const"](Data_Unit.unit))(traverse(Freer.eff)(v.value1));
        var body = function (v1) {
            var v2 = unsafeRun(execute)(block);
            if (v2 instanceof Data_Either.Left) {
                return pure(Effect_Unsafe.unsafePerformEffect(log(v2.value0)));
            };
            if (v2 instanceof Data_Either.Right) {
                return pure(Data_Unit.unit);
            };
            throw new Error("Failed pattern match at Machine (line 84, column 16 - line 86, column 27): " + [ v2.constructor.name ]);
        };
        return $foreign.register(v.value0, body, Data_Either.Left.create, Data_Either.Right.create);
    };
    if (v instanceof Select) {
        var thunk = function (block) {
            return function (v1) {
                return unsafeRun(execute)(block);
            };
        };
        var block2 = thunk(map(Data_Function["const"](Data_Unit.unit))(traverse(Freer.eff)(v.value1)));
        var block1 = thunk(map(Data_Function["const"](Data_Unit.unit))(traverse(Freer.eff)(v.value0)));
        return $foreign.select(block1, block2);
    };
    throw new Error("Failed pattern match at Machine (line 61, column 1 - line 61, column 36): " + [ v.constructor.name ]);
};
export {
    loadVal,
    loadRef,
    binOp,
    store,
    makeNode,
    setVal,
    setRef,
    select,
    register,
    call
} from "./foreign.js";
export {
    Noop,
    LoadVal,
    LoadRef,
    BinOp,
    MakeNode,
    Store,
    SetVal,
    SetRef,
    Select,
    Register,
    Call,
    execute,
    instructinoShow
};
